import { useState, useCallback } from 'react';
import { IJobFilterEntityOption, IOptionType } from '../Jobs/types';
import Api from '../Jobs/API';

interface FilterEntityOptionsResponse {
  res: {
    entities: IJobFilterEntityOption[];
  };
  resHead: {
    [key: string]: string;
  };
}

export const useEntityFilterOptions = () => {
  const [data, setData] = useState<IOptionType[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = useCallback(async (archived: boolean) => {
    setIsLoading(true);
    try {
      let page = 1;
      let totalPages = 9999;
      let results: IJobFilterEntityOption[] = [];

      while (page <= totalPages) {
        const response = (await Api.getJobFilterOptionsPaginated('entities', {
          'filter[archived]': archived,
          page
        })) as FilterEntityOptionsResponse;

        const currentPageData = response.res.entities || [];
        results = [...results, ...currentPageData];

        if (page === 1) {
          const transformedResults = results.map((entity) => ({
            id: entity.id,
            name: entity.name
          }));
          setData(transformedResults);
        }

        totalPages = parseInt(response.resHead?.['x-total-pages'] || '1');
        page += 1;
      }

      if (page > 1) {
        const transformedResults = results.map((entity) => ({
          id: entity.id,
          name: entity.name
        }));
        setData(transformedResults);
      }
    } catch (error) {
      console.error('Error fetching entities:', error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { data, isLoading, fetchData };
};
